// Service for the Attendance Dashboard "Mi equipo" — "Resumen del mes" monthly
// evolution bar charts (ASIS-5413 / REXASIS-012).
// GET /attendance/my-team/monthly-summary/evolution?cutoffCompanyId=1&monthlyCutId=1 —
// both query params are required: the company and monthly cutoff selected in the
// "Resumen del mes" filters panel (ASIS-5414).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyEvolutionOut,
  GetMyTeamMonthlyEvolutionParams,
  MyTeamMonthlyEvolution,
} from '../types/myTeamMonthlyEvolution.types';
import { mapMyTeamMonthlyEvolution } from '../mappers/myTeamMonthlyEvolution.mapper';


export class MyTeamMonthlyEvolutionService {
  async getEvolution(
    params: GetMyTeamMonthlyEvolutionParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyEvolution>> {
    const query = buildQueryString({
      cutoffCompanyId: params.cutoffCompanyId,
      monthlyCutId: params.monthlyCutId,
    });
    const { ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_EVOLUTION } = API_CONFIG.ENDPOINTS;
    const endpoint = `${ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_EVOLUTION}${query}`;
    const response = await apiClient.get<LC_GetMyTeamMonthlyEvolutionOut>(
      endpoint, { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyEvolution(response.data) };
  }
}

export const myTeamMonthlyEvolutionService = new MyTeamMonthlyEvolutionService();
